module.exports = __webpack_public_path__ + "img/pexels-frans-van-heerden-2881632.8c4be4fb.jpg";